<template>
  <b-overlay class="review-sim-card-overlay" :show="isLoading" spinner-small>
    <div class="review-sim-card">
      <slot name="txtBefore"></slot>
      <ShowPersonalData :customer="currentCustomer">
        <template v-for="slot in possibleChildSlotsFor('PersonalData')" v-slot:[`${slot.child}`]>
          <slot :name="`${slot.parent}`"></slot>
        </template>
      </ShowPersonalData>
      <slot name="txtAfter"></slot>
      <Stepper
        v-if="!isLoading"
        @prev="prev()"
        @next="next()"
        :loading-next="isStoreWorking"
        :disabled-next="!currentCustomer.lastName">
        <template v-for="slot in possibleChildSlotsFor('Stepper')" v-slot:[`${slot.child}`]>
          <slot :name="`${slot.parent}`"></slot>
        </template>
      </Stepper>
    </div>
  </b-overlay>
</template>

<script>
import processSteps from '@/mixins/processSteps'
import Stepper from '@/components/generic/Stepper.vue'
import ShowPersonalData from '@/components/process/generic/PersonalData/ShowPersonalData.vue'
import { mapMutations, mapState, mapActions } from 'vuex'
import { wrapQuery } from '@/helper/wrapGQLQuery'
import gql from 'graphql-tag'
import slotProxy from '@/mixins/slotProxy'
import { BOverlay } from 'bootstrap-vue'

export const stepName = 'reviewSimCard'

export default {
  name: 'ReviewSimCardType',
  components: {
    Stepper, ShowPersonalData, 'b-overlay': BOverlay
  },
  data () {
    return {
      currentCustomer: {
        salutation: '',
        firstName: '',
        lastName: '',
        birthDate: '',
        address: {
          city: '',
          houseNumber: '',
          street: '',
          supplement: '',
          zip: ''
        },
        email: ''
      }
    }
  },
  mixins: [
    processSteps(stepName),
    slotProxy()
  ],
  methods: {
    ...mapActions('substituteSimCard', [
      'requestSubstituteSimCard'
    ]),
    ...mapMutations('substituteSimCard', [
      'changeStep'
    ]),
    next () {
      this.requestSubstituteSimCard({ simCardType: this.simCardType, nextStep: this.nextStep })
    },
    prev () {
      this.changeStep({ step: this.previousStep })
    }
  },
  computed: {
    ...mapState('substituteSimCard', {
      simCardType: state => state.simCardType,
      isStoreWorking: state => state.working
    }),
    isLoading () {
      return !this.currentCustomer?.lastName || (this.$apollo.queries.currentCustomer ? this.$apollo.queries.currentCustomer.loading : true)
    }
  },
  apollo: {
    currentCustomer: function () {
      return wrapQuery(
        gql`query substituteSimCard {
          currentCustomer {
            salutation,
            firstName,
            birthDate,
            lastName,
            address {
              city,
              houseNumber,
              street,
              supplement,
              zip
            },
            email
          }
        }`, this, 'currentCustomer', {}, null,
        {
          fetchPolicy: 'cache-first'
        }
      )
    }
  }
}
</script>
